export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-16 pt-10 pb-24 text-center text-xs"
      style={{ borderTop: "1px solid var(--sb-border)", color: "var(--sb-text-muted)" }}
    >
      <div className="flex flex-wrap items-center justify-center gap-3 font-mono uppercase tracking-wider text-[10px] mb-4">
        <span>18+</span>
        <span>·</span>
        <a data-testid="footer-begambleaware-link" href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer" className="hover:text-white">BeGambleAware</a>
        <span>·</span>
        <a data-testid="footer-gamcare-link" href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer" className="hover:text-white">GamCare</a>
        <span>·</span>
        <a data-testid="footer-ukgc-link" href="https://www.gamblingcommission.gov.uk/" target="_blank" rel="noopener noreferrer" className="hover:text-white">UKGC</a>
      </div>
      <p className="max-w-xl mx-auto leading-relaxed px-4">
        Stats Betting shares football news and affiliate offers for entertainment purposes only.
        Gambling can be addictive — please play responsibly and only bet what you can afford to lose.
        Offers listed are for UK customers aged 18+. Full terms and conditions apply at each operator.
      </p>
      <div className="mt-4 flex flex-wrap items-center justify-center gap-4 font-mono uppercase tracking-wider text-[10px]">
        <a data-testid="footer-terms-link" href="#" className="hover:text-white">Terms</a>
        <a data-testid="footer-privacy-link" href="#" className="hover:text-white">Privacy</a>
        <a data-testid="footer-disclaimer-link" href="#" className="hover:text-white">Disclaimer</a>
      </div>
      <p className="mt-4 font-mono text-[10px]">© 2026 Stats Betting · @tipsterstats_1</p>
    </footer>
  );
}
